import clsx from 'clsx';
import { useIntl } from 'react-intl';
import type {
  GroupBase,
  PlaceholderProps as ReactSelectPlaceholderProps,
} from 'react-select';
import { components } from 'react-select';

import { _canReceiveDefaultTextFormat } from '@dynatrace/strato-components/core';

import {
  placeholderColorCSS,
  selectValueContainerTruncationBoxCSS,
} from '../styles/Select.sty.js';

type PlaceholderProps<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
> = ReactSelectPlaceholderProps<OptionValue, isMulti, Group>;

export function Placeholder<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
>(props: PlaceholderProps<OptionValue, isMulti, Group>) {
  const { selectProps } = props;
  const intl = useIntl();

  // do not truncate the text for non-text children
  if (
    selectProps.placeholderText &&
    !_canReceiveDefaultTextFormat(selectProps.placeholderText)
  ) {
    return (
      <components.Placeholder {...props} className={placeholderColorCSS}>
        {selectProps.placeholderText}
      </components.Placeholder>
    );
  }

  return (
    <components.Placeholder
      {...props}
      className={clsx(
        placeholderColorCSS,
        selectValueContainerTruncationBoxCSS,
      )}
    >
      {selectProps.placeholderText ??
        intl.formatMessage({
          defaultMessage: 'Select an option',
          id: 'BGeJvcEN6fCznnmo',
          description: 'Default placeholder text for the select.',
        })}
    </components.Placeholder>
  );
}
